import { ApiCallState, callInitiated } from '../../../types'
import { TickerRatingAction } from './actions'

export interface State {
  isOpen: boolean
  apiCall: ApiCallState
}

export const initialState: State = {
  isOpen: false,
  apiCall: { pending: false, error: false }
}

// open/close also clear any prior apiCall result so a reopened modal starts idle
export default (state = initialState, action: TickerRatingAction): State => {
  switch (action.type) {
    case 'tickerRating.open':
      return { isOpen: true, apiCall: initialState.apiCall }
    case 'tickerRating.close':
      return { isOpen: false, apiCall: initialState.apiCall }
    case 'tickerRating.save':
      return { ...state, apiCall: { ...callInitiated } }
    case 'tickerRating.result':
      return {
        ...state,
        apiCall: {
          pending: false,
          error: action.payload.error,
          status: action.payload.status
        }
      }
    default:
      return state
  }
}
